






































import { defineComponent } from '@nuxtjs/composition-api';

import useBiuraWyszukiwarkaService from '~/components/biura/services/useBiuraWyszukiwarkaService';
import Icon from '~/components/ui/icon.vue';
import VueSelect from '~/components/ui/vue-select.vue';

export default defineComponent({
  name: 'Wyszukiwarka',
  components: { VueSelect, Icon },
  props: {
    isMobile: {
      type: Boolean,
      default: () => false,
    },
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setup(props: unknown, { emit }) {
    return {
      ...useBiuraWyszukiwarkaService({ emit }),
    };
  },
});
